import { IPostComment } from '_interfaces/postComment.interface';

export const getSortedComments = (comments: IPostComment[]): IPostComment[] => {
  if (!comments || comments.length === 0) {
    return [];
  }

  const repliesLookup: Record<string, IPostComment[]> = {};
  comments.forEach((comment) => {
    if (comment.replyToCommentId) {
      if (!repliesLookup[comment.replyToCommentId]) {
        repliesLookup[comment.replyToCommentId] = [];
      }
      repliesLookup[comment.replyToCommentId].push(comment);
    }
  });

  const rootComments = comments
    .filter((c) => !c.replyToCommentId)
    .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());

  const sortedComments: IPostComment[] = [];
  const stack: IPostComment[] = [...rootComments];

  while (stack.length > 0) {
    const comment = stack.shift()!;
    sortedComments.push(comment);

    if (comment.id && repliesLookup[comment.id]) {
      const sortedReplies = repliesLookup[comment.id].sort(
        (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
      );
      stack.unshift(...sortedReplies);
    }
  }

  return sortedComments;
};
